import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9cd0076"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = ["data-edit", "innerHTML"]

import { withDefaults } from 'vue';

import { vMove, vInput, useCover } from './index';
type Pos = {
  left: number;
  top: number;
  center?: boolean;
  initHeight?: number;
  left2right?: boolean;
};
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1194.766 1110.189">
  <g transform="translate(2 -573.811)">
    <path d="M-617,793.928S-41.064,996.68,201.785,1051.316c4.272.961,8.383,1.877,12.4,2.761,236.222,52.023,361.582,0,361.582,0v748.905H-617Z" transform="translate(617 -121.244)" fill="var(--theme-color-1)" opacity="0.409"/>
    <path d="M1941.034,994.8H749.5V-115c2.267.472,4.56.989,6.817,1.535,12.54,3.033,25.744,6.716,39.243,10.946,13.214,4.14,27.076,8.919,41.2,14.2,27.321,10.221,56.738,22.748,87.433,37.233,29.267,13.811,60.47,29.767,92.742,47.425,30.657,16.775,63.081,35.524,96.37,55.726,115.162,69.891,245.754,160.091,388.149,268.094,55.94,42.43,113.86,87.743,172.15,134.683,46.632,37.551,93.6,76.22,139.609,114.934,78.389,65.962,127.335,109.669,127.82,110.1V994.794Z" transform="translate(-751 688.811)" fill="var(--theme-color-1)" opacity="0.458"/>
    <path d="M-617,874.879s359.179,76.462,573.7,150.936,619.685,284.138,619.685,284.138v488.941H-617Z" transform="translate(615 -114.895)" fill="var(--theme-color-1)"/>
  </g>
</svg>
`;


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-cover-7',
  props: {
    useEdit: { type: Boolean },
    projectName: {},
    time: {},
    mainPageEnterpriseName: {},
    titlePosition: {},
    settleTimePosition: {},
    aspNamePosition: {},
    orderNumber: {},
    orderNumberPostion: {}
  },
  emits: ['posChange', 'valueChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { info, onPosChange, onValueChange } = useCover(emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info), (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        "data-edit": _ctx.useEdit,
        key: index,
        class: _normalizeClass({ [item.className]: true }),
        innerHTML: props[item.valueKey]
      }, null, 10, _hoisted_2)), [
        [_unref(vMove), {
        pos: props[item.posKey],
        change: (left, top) => _unref(onPosChange)(item.posKey, left, top)
      }],
        [_unref(vInput), {
        value: props[item.valueKey],
        change: (value) => _unref(onValueChange)(item.valueKey, value)
      }]
      ])
    }), 128)),
    _createElementVNode("div", {
      innerHTML: svg,
      class: "svg"
    })
  ]))
}
}

})